import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {ChakraProvider, defaultSystem} from "@chakra-ui/react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ChakraProvider value={defaultSystem}>
        <App />
    </ChakraProvider>
);
